import utilActions from '@/utils/actions';

const verJsonAction = {
	id: 'idVerJsonAction',
	selectionType: 'single',
	label: 'action.vsincronizacionauditoria.verJson',
	functionality: 'READ_SINCRONIZACIONAUDITORIA',
	checkAvailability: function () {
		return true;
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		row.headerPk = utilActions.getPkFromModel(model, row);
		row.isAction = true;
		this.$puiEvents.$emit(
			'pui-modalDialogForm-vsincronizacionauditoriaVerJsonAction-' + model.name + '-show',
			row
		);
	}
};

const republicarAction = {
	id: 'idRepublicarAction',
	selectionType: 'single',
	label: 'action.vsincronizacionauditoria.republicar',
	functionality: 'REPUBLISH_SINCRONIZACIONAUDITORIA',
	checkAvailability: function (registries) {
		return registries[0] && registries[0].status !== 'REEMPLAZADA' && registries[0].idnotif > 0;
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		row.headerPk = utilActions.getPkFromModel(model, row);
		row.isAction = true;
		this.$puiEvents.$emit(
			'pui-modalDialogForm-vsincronizacionauditoriaRepublicarAction-' + model.name + '-show',
			row
		);
	}
};

export default {
	gridactions: [verJsonAction, republicarAction],
	formactions: []
};
